import { UserInterest } from "@/types";

import { axios } from "../axios.instance";

export type GetInterestsRequest = {
  search?: string;
  perPage: number;
};

export type GetInterestsResponse = {
  data: UserInterest[];
};

export const getInterests = async (body: GetInterestsRequest): Promise<GetInterestsResponse> => {
  const { data } = await axios.get("interests", { params: body });

  return data;
};
